// 引入request
import request from "@/utils/request";


//查询阅读 
export function getRead(uid) {
    return request({
      url: '/web/course/queryagegroup/'+uid,
      method: 'get',
    })
}

//查询查询阅读类型  params:data,
export function getReadingType(objId) { 
    return request({
      url: '/web/read/list/'+objId,
      method: 'get',
    })
}

//查询书籍 params:data,
export function getBook(bookId) { 
    return request({
      url: '/web/read/book/list/'+bookId,
      method: 'get',
    })
}

//查询书籍章节
export function getSections(data) { 
  return request({
    url: '/web/read/chapter/list',
    method: 'get',
    params:data,
  })
}


//查询已读文章
export function getReadArticle(memberId) { 
  return request({
    url: '/web/read/chapter/queryreadarticle/'+memberId,
    method: 'get',
  })
}



//查询阅读排行榜
export function readingRanking(memberId) { 
  return request({
    url: '/web/read/chapter/classReadingRanking/'+memberId,
    method: 'get',
  })
}

//查询自己阅读排行
export function SelfRanking(menId) { 
  return request({
    url: '/web/read/chapter/readingRanking/'+menId,
    method: 'get',
  })
}


//查询年级阅读排行
export function GradeRanking(menId) { 
  return request({
    url: '/web/read/chapter/gradeReadingRanking/'+menId,
    method: 'get',
  })
}



